import { render, staticRenderFns } from "./goDieUnlucky.vue?vue&type=template&id=52978b5c&scoped=true&"
import script from "./goDieUnlucky.vue?vue&type=script&lang=js&"
export * from "./goDieUnlucky.vue?vue&type=script&lang=js&"
import style0 from "./goDieUnlucky.vue?vue&type=style&index=0&id=52978b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52978b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52978b5c')) {
      api.createRecord('52978b5c', component.options)
    } else {
      api.reload('52978b5c', component.options)
    }
    module.hot.accept("./goDieUnlucky.vue?vue&type=template&id=52978b5c&scoped=true&", function () {
      api.rerender('52978b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/goDieUnlucky.vue"
export default component.exports